var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalizedAboutMeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.1297 201.603H51.3296C38.9584 201.603 28.9296 191.574 28.9297 179.203L28.9306 44.8032C28.9306 32.4321 38.9594 22.4033 51.3306 22.4033H152.133C164.504 22.4033 174.533 32.4321 174.533 44.8033V106.403M129.733 169.87L150.267 190.403L195.067 145.602M68.1332 67.2033H135.333M68.1332 100.803H135.333M68.1332 134.403H101.733",
    stroke: "#E8EAED",
    strokeWidth: 18.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizedAboutMeAlt);
export default __webpack_public_path__ + "static/media/personalized-about-me-alt.819466942343120d78a0a2e78ebcdbbd.svg";
export { ForwardRef as ReactComponent };